//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            checkStrictly: false,
            data: [],
            columns: [],
            rowSelection: {},
            formState: {
                options: '0'
            }
        }
    },
    mounted() {
        this.columns.push({ title: '區域名稱', dataIndex: 'name', key: 'name', })
        this.columns.push({ title: '場館狀態', dataIndex: 'status', key: 'status', scopedSlots: { customRender: 'status' }, })
        this.columns.push({
            title: '操作',
            key: 'operation',
            width: 280,
            scopedSlots: { customRender: 'action' },
        });
        this.data.push({
            name: '場館1',
            status: '啟用'
        })
    },
    methods: {
        handleFinish() {

        },
        handleFinishFailed() {

        },
    }
}
